import { HeaderState, SimpleAction } from 'types'

export const initialState = {
  headerVisible: false,
}

export const reducer = (state: HeaderState = initialState, action: SimpleAction) => {
  switch (action.type) {
    case 'TOGGLE_STICKY_HEADER': {
      return {
        ...state,
        headerVisible: action.data,
      }
    }

    default:
      return state
  }
}

export default reducer
